import { Container, Logo } from "./HeaderElements";
import logo from "../../Images/whiteLogo.png";
const Header = () => {
  return (
    <>
      <Container>
        <Logo src={logo} />
      </Container>
    </>
  );
};

export default Header;
